import { FieldFormat } from '../components/Table/Table';
import { FILTER_LABELS, FILTER_NAMES } from '../types';

export const dueDiligenceFilterOptions = [
  { label: FILTER_LABELS.APPROVED, name: FILTER_NAMES.APPROVED },
  { label: FILTER_LABELS.DECLINED, name: FILTER_NAMES.DECLINED },
  { label: FILTER_LABELS.AWAITING_ASSESSMENT, name: FILTER_NAMES.AWAITING_ASSESSMENT },
  { label: FILTER_LABELS.ALL, name: FILTER_NAMES.ALL },
];

export const firmsTableProperties = [
  {
    alias: 'firmName',
    name: 'Firm name',
    sortable: false,
  },
  {
    alias: 'firmEmail',
    name: 'Email',
    sortable: false,
  },
  {
    alias: 'fcaNumber',
    name: 'FCA number',
    sortable: false,
  },
  {
    alias: 'firmLocation',
    name: 'Location',
    sortable: false,
  },
  {
    alias: 'registeredAt',
    name: 'Date registered',
    format: FieldFormat.Date,
    sortable: false,
  },
  {
    alias: 'lmcStatus',
    name: 'Portal status',
    format: FieldFormat.Boolean,
    sortable: false,
  },
  {
    alias: 'ddStatus',
    name: 'DD Status',
    format: FieldFormat.DDStatus,
    sortable: false,
  },
];
